/**
 * Upsell Popup Functionality
 * Handles the display and interaction of the upsell popup similar to Huel's design
 */

// class UpsellPopup {
//   constructor() {
//     this.popup = document.getElementById('upsell-popup');
//     this.slider = document.getElementById('upsell-products-slider');
//     this.loading = document.getElementById('upsell-loading');
//     this.dots = document.getElementById('upsell-dots');
//     this.prevButton = document.getElementById('upsell-prev');
//     this.nextButton = document.getElementById('upsell-next');
//     this.cartButton = document.getElementById('upsell-cart-button');
//     this.shippingProgress = document.getElementById('upsell-shipping-progress');
//     this.shippingText = document.getElementById('shipping-bar-text');
    
//     this.currentSlide = 0;
//     this.productsPerSlide = window.innerWidth <= 768 ? 1 : 2;
//     this.totalSlides = 0;
//     this.upsellProducts = [];
//     this.cartData = null;
    
//     this.init();
//   }

//   init() {
//     this.bindEvents();
//     this.setupShippingBar();
//   }

//   bindEvents() {
//     // Close popup events
//     this.popup?.querySelector('.upsell-popup__close')?.addEventListener('click', () => this.close());
//     this.popup?.querySelector('.upsell-popup__overlay')?.addEventListener('click', () => this.close());
    
//     // Navigation events
//     this.prevButton?.addEventListener('click', () => this.previousSlide());
//     this.nextButton?.addEventListener('click', () => this.nextSlide());
    
//     // Cart button
//     this.cartButton?.addEventListener('click', () => this.openCartDrawer());
    
//     // Add to cart buttons (delegated event)
//     this.popup?.addEventListener('click', (e) => {
//       if (e.target.classList.contains('upsell-product__add-button')) {
//         e.preventDefault();
//         this.addUpsellToCart(e.target);
//       }
//     });

//     // Listen for cart updates to update shipping bar
//     document.addEventListener('cart:updated', (e) => {
//       this.updateShippingBar(e.detail.cart);
//     });

//     // Handle window resize
//     window.addEventListener('resize', () => {
//       this.productsPerSlide = window.innerWidth <= 768 ? 1 : 2;
//       this.updateSlider();
//     });

//     // Keyboard navigation
//     document.addEventListener('keydown', (e) => {
//       if (this.popup?.style.display !== 'none') {
//         if (e.key === 'Escape') this.close();
//         if (e.key === 'ArrowLeft') this.previousSlide();
//         if (e.key === 'ArrowRight') this.nextSlide();
//       }
//     });
//   }

//   setupShippingBar() {
//     // Get shipping thresholds from upsell config
//     this.shippingThresholds = window.upsellConfig?.shippingTiers || {
//       freeShipping: 5000, // 50€ in cents
//       tier1: null,
//       tier2: null,
//       tier3: null,
//       tier4: null,
//       tier5: null,
//       tier6: null
//     };

//     console.log('Shipping thresholds:', {
//         freeShipping: this.shippingThresholds.freeShipping,
//         tier1: this.shippingThresholds.freeShipping,
//         tier2: this.shippingThresholds.tier2,
//         tier3: this.shippingThresholds.tier3,
//         tier4: this.shippingThresholds.tier4,
//         tier5: this.shippingThresholds.tier5,
//         tier6: this.shippingThresholds.tier6
//     });
    
//     // Get the maximum threshold for progress bar calculation
//     this.maxThreshold = Math.max(
//       this.shippingThresholds.freeShipping,
//       this.shippingThresholds.tier1 || 0,
//       this.shippingThresholds.tier2 || 0,
//       this.shippingThresholds.tier3 || 0,
//       this.shippingThresholds.tier4 || 0,
//       this.shippingThresholds.tier5 || 0,
//       this.shippingThresholds.tier6 || 0
//     );
    
//     // Get tier messages from upsell config
//     this.tierMessages = window.upsellConfig?.tierMessages || {
//       freeShipping: 'Dir fehlen nur noch {amount} bis zum Gratis-Versand!',
//       tier1: 'Dir fehlen nur noch {amount} bis zum ersten Geschenk!',
//       tier2: 'Dir fehlen nur noch {amount} bis zum zweiten Geschenk!',
//       tier3: 'Dir fehlen nur noch {amount} bis zum dritten Geschenk!',
//       tier4: 'Dir fehlen nur noch {amount} bis zum vierten Geschenk!',
//       tier5: 'Dir fehlen nur noch {amount} bis zum fünften Geschenk!',
//       tier6: 'Dir fehlen nur noch {amount} bis zum sechsten Geschenk!',
//       maxReached: 'Alle Geschenke erreicht! 🎉'
//     };
//   }

//   showLoading() {
//     if (this.loading) {
//       this.loading.style.display = 'flex';
//     }
//     if (this.slider) {
//       this.slider.style.display = 'none';
//     }
//     // Hide navigation while loading
//     const navigation = this.popup?.querySelector('.upsell-popup__navigation');
//     if (navigation) {
//       navigation.style.display = 'none';
//     }
//   }

//   hideLoading() {
//     if (this.loading) {
//       this.loading.style.display = 'none';
//     }
//     if (this.slider) {
//       this.slider.style.display = 'flex';
//     }
//     // Show navigation after loading
//     const navigation = this.popup?.querySelector('.upsell-popup__navigation');
//     if (navigation) {
//       navigation.style.display = 'flex';
//     }
//   }

//   show(cartData, addedProduct) {
//     // Check if upsell popup is enabled
//     if (!window.upsellConfig?.enabled) {
//       this.openCartDrawer();
//       return;
//     }
    
//     this.cartData = cartData;
//     this.popup.style.display = 'flex';
//     document.body.style.overflow = 'hidden';
    
//     // Update shipping bar
//     this.updateShippingBar(cartData);
    
//     // Load upsell products with delay
//     const delay = window.upsellConfig?.delayBeforeShow || 500;
//     setTimeout(() => {
//       this.loadUpsellProducts(addedProduct);
//     }, delay);
    
//     // Focus management
//     this.popup.focus();
//   }

//   close() {
//     // Refresh the cart drawer
//     document.documentElement.dispatchEvent(
//       new CustomEvent('cart:refresh', {
//         bubbles: true,
//         detail: {
//           cart: this.cartData,
//           openMiniCart: false, // Don't auto-open cart drawer
//         },
//       })
//     );
    
//     this.popup.style.display = 'none';
//     document.body.style.overflow = '';
//     this.currentSlide = 0;
//     // Reset loading state
//     this.hideLoading();
//   }

//   async loadUpsellProducts(addedProduct) {
    
//     // Show loading state
//     this.showLoading();
    
//     try {
//       // Get recommended products based on the added product
//       const recommendations = await this.getProductRecommendations(addedProduct);
      
//       this.upsellProducts = recommendations;
      
//       if (recommendations.length > 0) {
//         this.renderProducts();
//         this.updateNavigation();
//         this.hideLoading();
//       } else {
//         console.warn('No recommendations to display');
//         // Hide the products section if no recommendations
//         const productsSection = this.popup.querySelector('.upsell-popup__products');
//         if (productsSection) {
//           productsSection.style.display = 'none';
//         }
//         this.hideLoading();
//       }
//     } catch (error) {
//       console.error('Error loading upsell products:', error);
//       // Hide the products section if no recommendations
//       const productsSection = this.popup.querySelector('.upsell-popup__products');
//       if (productsSection) {
//         productsSection.style.display = 'none';
//       }
//       this.hideLoading();
//     }
//   }

//   async getProductRecommendations(addedProduct) {
//     const recommendations = [];
    
//     // First try to get popular products as a reliable fallback
//     try {
//       const popularProducts = await this.getPopularProducts(addedProduct);
//       recommendations.push(...popularProducts);
//     } catch (error) {
//       console.error('Error fetching popular products:', error);
//     }
    
//     // If we have a product handle, try to get related products
//     if (addedProduct?.handle && recommendations.length > 0) {
//       try {
//         const response = await fetch(`/products/${addedProduct.handle}.js`);
//         if (response.ok) {
//           const product = await response.json();
          
//           // Find related products (simplified logic)
//           const relatedProducts = await this.findRelatedProducts(product);
//           if (relatedProducts.length > 0) {
//             // Replace some popular products with related ones
//             const maxProducts = window.upsellConfig?.maxRecommendations || 4;
//             const relatedCount = Math.min(relatedProducts.length, Math.floor(maxProducts / 2));
//             recommendations.splice(0, relatedCount, ...relatedProducts.slice(0, relatedCount));
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching product for recommendations:', error);
//       }
//     }
    
//     // Ensure we have at least some products
//     if (recommendations.length === 0) {
//       console.warn('No recommendations found, using fallback');
//       // Fallback to a simple collection fetch
//       try {
//         const response = await fetch('/collections/all/products.json?limit=4');
//         const data = await response.json();
//         recommendations.push(...data.products.filter(p => p.available));
//       } catch (error) {
//         console.error('Fallback recommendation fetch failed:', error);
//       }
//     }
    
//     return recommendations;
//   }

//   async findRelatedProducts(product) {
//     const relatedProducts = [];
    
//     // Find products with similar tags
//     if (product.tags && product.tags.length > 0) {
//       try {
//         // Try to find products with the same first tag
//         const tag = product.tags[0];
//         const response = await fetch(`/collections/all/products.json?limit=20`);
//         const data = await response.json();
        
//         const taggedProducts = data.products.filter(p => 
//           p.id !== product.id && 
//           p.tags && p.tags.includes(tag) && 
//           p.available
//         );
        
//         relatedProducts.push(...taggedProducts);
        
//         // If we don't have enough products, try with other tags
//         if (relatedProducts.length < 2 && product.tags.length > 1) {
//           for (let i = 1; i < product.tags.length && relatedProducts.length < 4; i++) {
//             const additionalTag = product.tags[i];
//             const additionalProducts = data.products.filter(p => 
//               p.id !== product.id && 
//               p.tags && p.tags.includes(additionalTag) && 
//               p.available &&
//               !relatedProducts.some(rp => rp.id === p.id)
//             );
//             relatedProducts.push(...additionalProducts.slice(0, 2));
//           }
//         }
//       } catch (error) {
//         console.error('Error finding related products:', error);
//       }
//     }
    
//     return relatedProducts;
//   }

//   async getPopularProducts(addedProduct) {
//     try {
//       const productId = addedProduct.product_id;
//       const intent = 'related';
//       const response = await fetch(`/recommendations/products.json?product_id=${productId}&intent=${intent}`);
//       const data = await response.json();
//       return data.products.filter(p => p.available);
//     } catch (error) {
//       console.error('Error fetching popular products:', error);
//       return [];
//     }
//   }

//   renderProducts() {
//     if (!this.slider) {
//       console.error('Slider element not found');
//       return;
//     }
    
//     if (this.upsellProducts.length === 0) {
//       console.warn('No products to render');
//       return;
//     }
    
//     this.slider.innerHTML = '';
//     const template = document.getElementById('upsell-product-template');
    
//     if (!template) {
//       console.error('Product template not found, creating fallback');
//       // Create a simple fallback without template
//       this.upsellProducts.forEach((product, index) => {
//         const productElement = this.createFallbackProductElement(product);
//         this.slider.appendChild(productElement);
//       });
//     } else {
//       this.upsellProducts.forEach((product, index) => {
//         const productElement = this.createProductElement(product, template);
//         this.slider.appendChild(productElement);
//       });
//     }
//     this.totalSlides = this.slider.querySelectorAll('.upsell-product:not([style*="display: none"])').length;
//     console.log('totalSlides:', this.totalSlides);
//     this.updateSlider();
//   }

//   createProductElement(product, template) {
//     const element = template.content.cloneNode(true);
//     const productEl = element.querySelector('.upsell-product');
//     if (product.title.includes('Bundle') || product.title.includes('Gratis')) {
//       productEl.style.display = 'none';
//     }
    
//     if (!productEl) {
//       console.error('Product element not found in template');
//       return element;
//     }
    
//     // Set product data
//     const img = productEl.querySelector('.upsell-product__img');
//     const title = productEl.querySelector('.upsell-product__title');
//     const priceCurrent = productEl.querySelector('.upsell-product__price-current');
//     const priceCompare = productEl.querySelector('.upsell-product__price-compare');
//     const addButton = productEl.querySelector('.upsell-product__add-button');
    
//     // Product image
//     if (product.featured_image) {
//       img.src = product.featured_image;
//       img.alt = product.title;
//     } else {
//       console.warn('No featured image for product:', product.title);
//     }
    
//     // Product title
//     title.textContent = product.title.split('(')[0];
    
//     // Product price
//     const variant = product.variants?.[0];
//     if (variant) {
//       const currentPrice = this.formatPrice(variant.price);
//       priceCurrent.textContent = currentPrice;
      
//       if (variant.compare_at_price && variant.compare_at_price > variant.price) {
//         const comparePrice = this.formatPrice(variant.compare_at_price);
//         priceCompare.textContent = comparePrice;
//         priceCompare.style.display = 'inline';
//       }
      
//       addButton.dataset.variantId = variant.id;
//     } else {
//       console.warn('No variant found for product:', product.title);
//     }
    
//     // Product features (if available)
//     const features = productEl.querySelector('.upsell-product__features');
//     if (product.metafields?.custom?.features) {
//       features.textContent = product.metafields.custom.features;
//     } else if (product.tags && product.tags.length > 0) {
//       features.textContent = product.tags.slice(0, 2).join(' • ');
//     }
    
//     return element;
//   }

//   createFallbackProductElement(product) {
//     const div = document.createElement('div');
//     div.className = 'upsell-product';
    
//     const variant = product.variants?.[0];
//     const price = variant ? this.formatPrice(variant.price) : 'N/A';
    
//     div.innerHTML = `

//       <a href="${product.url}" class="upsell-product__image">
//         <img src="${product.featured_image || ''}" alt="${product.title}" class="upsell-product__img">
//       </a>
//       <div class="upsell-product__content">
//         <h4 class="upsell-product__title">${product.title.split('(')[0]}</h4>
//         <div class="upsell-product__details">
//           <div class="upsell-product__price">
//             <span class="upsell-product__price-current">${price}</span>
//           </div>
//           <div class="upsell-product__features">
//             ${product.tags ? product.tags.slice(0, 2).join(' • ') : ''}
//           </div>
//         </div>
//         <button type="button" class="upsell-product__add-button" data-variant-id="${variant?.id || ''}">
//           In den Warenkorb
//         </button>
//       </div>
//     `;
    
//     return div;
//   }

//   formatPrice(priceInCents) {
//     const price = priceInCents / 100;
//     return new Intl.NumberFormat('de-DE', {
//       style: 'currency',
//       currency: 'EUR'
//     }).format(price);
//   }

//   updateSlider() {
//     if (!this.slider) return;
    
//     const slideWidth = this.slider.querySelector('.upsell-product:not([style*="display: none"])').offsetWidth;
//     console.log('slideWidth:', slideWidth);
//     const translateX = -this.currentSlide * (slideWidth + 20);
//     this.slider.style.transform = `translateX(${translateX}px)`;
    
//     // Update navigation buttons
//     this.prevButton.disabled = this.currentSlide === 0;
//     this.nextButton.disabled = this.currentSlide >= this.totalSlides - 1;
//   }

//   updateNavigation() {
//     if (!this.dots) return;
    
//     this.dots.innerHTML = '';
    
//     for (let i = 0; i < this.totalSlides; i++) {
//       const dot = document.createElement('div');
//       dot.className = `upsell-popup__dot ${i === this.currentSlide ? 'active' : ''}`;
//       dot.addEventListener('click', () => this.goToSlide(i));
//       this.dots.appendChild(dot);
//     }
//   }

//   previousSlide() {
//     if (this.currentSlide > 0) {
//       this.currentSlide--;
//       this.updateSlider();
//       this.updateDots();
//     }
//   }

//   nextSlide() {
//     if (this.currentSlide < this.totalSlides - 1) {
//       this.currentSlide++;
//       this.updateSlider();
//       this.updateDots();
//     }
//   }

//   goToSlide(index) {
//     this.currentSlide = index;
//     this.updateSlider();
//     this.updateDots();
//   }

//   updateDots() {
//     const dots = this.dots?.querySelectorAll('.upsell-popup__dot');
//     dots?.forEach((dot, index) => {
//       dot.classList.toggle('active', index === this.currentSlide);
//     });
//   }

//   async addUpsellToCart(button) {
//     const variantId = button.dataset.variantId;
//     if (!variantId) return;
    
//     button.classList.add('loading');
//     button.disabled = true;
    
//     try {
//       const formData = new FormData();
//       formData.append('id', variantId);
//       formData.append('quantity', 1);
//       formData.append('sections', 'mini-cart');
      
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//         },
//       });
      
//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.description || 'Failed to add product to cart.');
//       }
      
//       const responseJson = await response.json();
      
//       // Dispatch variant:added event
//       document.dispatchEvent(
//         new CustomEvent('variant:added', {
//           bubbles: true,
//           detail: {
//             variant: responseJson.hasOwnProperty('items') ? responseJson.items[0] : responseJson,
//           },
//         })
//       );
      
//       // Fetch updated cart data
//       const cartResponse = await fetch('/cart.js');
//       const cartContent = await cartResponse.json();
      
//       // Dispatch cart:updated event
//       document.documentElement.dispatchEvent(
//         new CustomEvent('cart:updated', {
//           bubbles: true,
//           detail: {
//             cart: cartContent,
//           },
//         })
//       );
      
//       // Add mini-cart section to cart content
//       cartContent.sections = responseJson.sections;
      
//       // Update our cart data
//       this.cartData = cartContent;
//       this.updateShippingBar(cartContent);
      
//       // Show success feedback
//       button.textContent = 'Hinzugefügt!';
//       button.classList.remove('loading');
//       button.disabled = false;
//       setTimeout(() => {
//         button.textContent = 'In den Warenkorb'; 
//       }, 2000);
      
//     } catch (error) {
//       console.error('Error adding upsell to cart:', error);
//       button.textContent = 'Fehler';
//       setTimeout(() => {
//         button.textContent = 'In den Warenkorb';
//         button.classList.remove('loading');
//         button.disabled = false;
//       }, 2000);
//     }
//   }

//   updateShippingBar(cartData) {
//     if (!this.shippingProgress || !this.shippingText) return;
    
//     const totalPrice = cartData.total_price / 100 || 0;
//     const progress = Math.min(totalPrice / this.maxThreshold, 1);

    
//     // Update progress bar
//     this.shippingProgress.style.setProperty('--progress', progress);
    
//     // Update marker positions and active states
//     this.updateShippingMarkers(totalPrice);
    
//     // Update text based on current tier
//     this.updateShippingText(totalPrice);
//   }
  
//   updateShippingMarkers(totalPrice) {
//     // Update free shipping marker
//     const shippingLine = this.shippingProgress.querySelector('#shipping-line');
//     if (shippingLine) {
//       const position = (this.shippingThresholds.freeShipping / this.maxThreshold) * 100;
//       shippingLine.style.left = `${position}%`;
//       shippingLine.classList.toggle('active', totalPrice >= this.shippingThresholds.freeShipping);
//     }
    
//     // Update gift tier markers
//     for (let i = 1; i <= 6; i++) {
//       const tierKey = `tier${i}`;
//       const threshold = this.shippingThresholds[tierKey];
//       const giftLine = this.shippingProgress.querySelector(`#gift-line-${i}`);
      
//       if (threshold && giftLine) {
//         const position = (threshold / this.maxThreshold) * 100;
//         giftLine.style.left = `${position}%`;
//         giftLine.classList.toggle('active', totalPrice >= threshold);
//       }
//     }
//   }
  
//   updateShippingText(totalPrice) {
//     let message = '';
//     let remainingAmount = 0;
    
//     // Determine which tier message to show
//     if (totalPrice < this.shippingThresholds.freeShipping) {
//       remainingAmount = this.shippingThresholds.freeShipping - totalPrice;
//       message = this.tierMessages.freeShipping;
//     } else if (this.shippingThresholds.tier1 && totalPrice < this.shippingThresholds.tier1) {
//       remainingAmount = this.shippingThresholds.tier1 - totalPrice;
//       message = this.tierMessages.tier1;
//     } else if (this.shippingThresholds.tier2 && totalPrice < this.shippingThresholds.tier2) {
//       remainingAmount = this.shippingThresholds.tier2 - totalPrice;
//       message = this.tierMessages.tier2;
//     } else if (this.shippingThresholds.tier3 && totalPrice < this.shippingThresholds.tier3) {
//       remainingAmount = this.shippingThresholds.tier3 - totalPrice;
//       message = this.tierMessages.tier3;
//     } else if (this.shippingThresholds.tier4 && totalPrice < this.shippingThresholds.tier4) {
//       remainingAmount = this.shippingThresholds.tier4 - totalPrice;
//       message = this.tierMessages.tier4;
//     } else if (this.shippingThresholds.tier5 && totalPrice < this.shippingThresholds.tier5) {
//       remainingAmount = this.shippingThresholds.tier5 - totalPrice;
//       message = this.tierMessages.tier5;
//     } else if (this.shippingThresholds.tier6 && totalPrice < this.shippingThresholds.tier6) {
//       remainingAmount = this.shippingThresholds.tier6 - totalPrice;
//       message = this.tierMessages.tier6;
//     } else {
//       message = this.tierMessages.maxReached;
//     }

//     console.log('remainingAmount:', remainingAmount);
    
//     // Replace {amount} placeholder with formatted amount
//     if (remainingAmount > 0) {
//       const formattedAmount = this.formatPrice(remainingAmount * 100);
//       message = message.replace('[amount]', formattedAmount);
//     }
    
//     this.shippingText.innerHTML = message;
//   }

//   openCartDrawer() {
//     // Dispatch cart:refresh event to open cart drawer
//     document.documentElement.dispatchEvent(
//       new CustomEvent('cart:refresh', {
//         bubbles: true,
//         detail: {
//           cart: this.cartData,
//           openMiniCart: true,
//         },
//       })
//     );
    
//     this.close();
//   }
// }

// // Initialize the upsell popup when DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
//   window.upsellPopup = new UpsellPopup();
// });

// // Export for use in other scripts
// if (typeof module !== 'undefined' && module.exports) {
//   module.exports = UpsellPopup;
// }

































// AB TEST POPUP



// Helper: run when DOM is ready
function domReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}

// Helper: wait for element to exist (optional root, e.g. shadowRoot, to query inside)
function waitForElement(selector, callback, intervalTime = 100, timeout = 10000, root = null) {
  const start = Date.now();
  const doc = root || document;

  const interval = setInterval(() => {
    const elems = doc.querySelectorAll(selector);

    if (elems.length > 0) {
      clearInterval(interval);
      elems.forEach((el) => callback(el));
    } else if (Date.now() - start > timeout) {
      clearInterval(interval);
    }
  }, intervalTime);
}


let addedUpsell = [];

function preventCartOpening() {
  const cart = document.querySelector('#mini-cart');
  if (!cart) return;
  
  cart.style.display = 'none';

  setTimeout(() => {
    const closeBtn = cart.querySelector('.drawer__close-button');
    if (closeBtn) {
      closeBtn.click();
    }

    setTimeout(() => {
      cart.style.removeProperty('display');
    }, 250);
  }, 2000);

  // Also prevent cart:refresh from opening cart for a short period
  const preventHandler = (event) => {
    if (event.detail && event.detail.openMiniCart) {
      event.detail.openMiniCart = false;
    }
  };
  
  document.documentElement.addEventListener('cart:refresh', preventHandler, true);
  
  // Remove the handler after 3 seconds (enough time for recommendations to load)
  setTimeout(() => {
    document.documentElement.removeEventListener('cart:refresh', preventHandler, true);
  }, 3000);
}

function addPopup() {
  const pdpTitle = document.querySelector('.product-meta__title');
  const pdpImg = document.querySelector('.flickity-slider .product__media-item:first-child .product__media-image-wrapper > img');

  const popupHTML = `
    <div class="ve-0014-overlay"></div>
    <div class="ve-0014">
      <div class="ve-0014-header">
        <h1>PRODUKT HINZUGEFÜGT</h1>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.28 0.719971L0.719971 11.28M0.719971 0.719971L11.28 11.28" stroke="#121923" stroke-width="1.5"/>
        </svg>
      </div>
      <div class="ve-0014-content">
        <div class="ve-0014-content-banner">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="#F1F7ED"/>
            <path d="M17.12 19.6464L19.2718 21.9201L23.36 17.6001M27.68 20.0001C27.68 24.2416 24.2416 27.6801 20 27.6801C15.7585 27.6801 12.32 24.2416 12.32 20.0001C12.32 15.7585 15.7585 12.3201 20 12.3201C24.2416 12.3201 27.68 15.7585 27.68 20.0001Z" stroke="#8EBF88" stroke-width="1.5"/>
          </svg>
          <p>Dieser Artikel wurde deinem Warenkorb hinzugefügt.</p>
        </div>
        <div class="ve-0014-product">
          <img src="${pdpImg.src}">
          <h3>${pdpTitle.innerHTML}</h3>
          <p class="ve-0014-product-price"></p>
          <div class="ve-0014-product-qt">
            <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 1H12" stroke="#0D0D0D" stroke-width="1.5"/>
            </svg>
            <span></span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 0V12M0 6H12" stroke="#0D0D0D" stroke-width="1.5"/>
            </svg>
          </div>
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.800049 4.23999H15.2M5.60005 4.23999V2.31999C5.60005 1.7898 6.02984 1.35999 6.56005 1.35999H9.44005C9.97026 1.35999 10.4 1.7898 10.4 2.31999V4.23999M8.00005 6.63999V14.32M10.88 6.63999L10.4 14.32M5.12005 6.63999L5.60005 14.32M13.76 4.23999L12.8682 15.8336C12.8297 16.3338 12.4127 16.72 11.9111 16.72H4.08904C3.5874 16.72 3.17034 16.3338 3.13187 15.8336L2.24005 4.23999H13.76Z" stroke="#0D0D0D" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="ve-0014-upsell">
          <h2>Das könnte dir auch gefallen:</h2>
          <div class="ve-0014-upsell-list">
          </div>
        </div>
      </div>
      <div class="ve-0014-footer">
        <div class="ve-0014-footer-close">
          WEITER EINKAUFEN
        </div>
        <div class="ve-0014-footer-cart">
          ZUM WARENKORB
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', popupHTML);
}

function setupPopup() {
  const popup = document.querySelector('.ve-0014');
  const closeBtns = document.querySelectorAll('.ve-0014-footer-close, .ve-0014-header svg, .ve-0014-overlay');
  closeBtns.forEach((b) => {
    b.addEventListener('click', () => {
      closePopup();
    });
  });

  // Prevent cart from opening when popup is open
  // Intercept cart:refresh events and prevent openMiniCart when popup is visible
  const preventCartOpenHandler = (event) => {
    if (popup && popup.classList.contains('ve-0014-open')) {
      if (event.detail && event.detail.openMiniCart) {
        event.detail.openMiniCart = false;
      }
    }
  };
  document.documentElement.addEventListener('cart:refresh', preventCartOpenHandler, true);

  const cartBtn = popup.querySelector('.ve-0014-footer-cart');
  cartBtn.addEventListener('click', () => {
    const cartOpenBtn =  document.querySelector('.header__icon-wrapper[href*="/cart"]');
    closePopup();
    cartOpenBtn.click();
  });

  const qtMinus = document.querySelector('.ve-0014-product-qt svg:first-child');
  const qtPlus = document.querySelector('.ve-0014-product-qt svg:last-child');
  const removeBtn = document.querySelector('.ve-0014-product > svg');
  let btnTimeout = false;

  const removeProduct = () => {
    const cartProduct = getProductInCart();
    const cartRemove = cartProduct.querySelector('.line-item__remove-button');
    cartRemove.click();
    closePopup();
  };

  removeBtn.addEventListener('click', () => {
    if (btnTimeout === true) {
      return;
    }

    removeProduct();

    btnTimeout = true;
    setTimeout(() => {
      btnTimeout = false;
    }, 1000);
  });

  qtMinus.addEventListener('click', () => {
    if (btnTimeout === true) {
      return;
    }

    const productQt = popup.querySelector('.ve-0014-product-qt span');
    const qt = parseInt(productQt.innerHTML);

    const cartProduct = getProductInCart();
    const btnMinus = cartProduct.querySelector('.quantity-selector__button[aria-label="Menge verringern"]');

    if (qt > 1) {
      productQt.innerHTML = qt - 1;
      btnMinus.click();
    } else {
      removeProduct();
    }

    btnTimeout = true;
    setTimeout(() => {
      btnTimeout = false;
    }, 1000);
  });

  qtPlus.addEventListener('click', () => {
    if (btnTimeout === true) {
      return;
    }

    const productQt = popup.querySelector('.ve-0014-product-qt span');
    const qt = parseInt(productQt.innerHTML);

    const cartProduct = getProductInCart();
    const btnPlus = cartProduct.querySelector('.quantity-selector__button[aria-label="Menge erhöhen"]');

    productQt.innerHTML = qt + 1;
    btnPlus.click();

    btnTimeout = true;
    setTimeout(() => {
      btnTimeout = false;
    }, 1000);
  });
}

function getProductInCart() {
  const id = document.querySelector('.product-form__buy-buttons form input[name="id"]');
  const isAbo = document.querySelector('.subscription-radio.rc-radio--active') !== null;

  if (isAbo) {
    const timeSelector = document.querySelector('.rc-selling-plans-dropdown__select');
    const text = timeSelector.querySelector(`option[value="${timeSelector.value}`).innerHTML;

    const cartItems = document.querySelectorAll(`.line-item[data-vid="${id.value}"]:has(.product-item-meta__property)`);
    for (item of cartItems) {
      const textField = item.querySelector('.product-item-meta__property');

      if (textField.innerHTML.trim() === text.trim()) {
        return item;
      }
    }
  } else {
    return document.querySelector(`.line-item[data-vid="${id.value}"]:not(:has(.product-item-meta__property))`);
  }
}

async function loadUpsell() {
  const upsellPopup = document.querySelector('.ve-0014-upsell-list');
  upsellPopup.innerHTML = '';

  // First, render already added upsell products
  addedUpsell.forEach((u) => {
    const upsellHTML = `
      <div>
        <img src="${u.img}">
        <h3>${u.title}</h3>
        <p>${u.price}</p>
        <div class="ve-0014-upsell-delete">
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.800049 4.23999H15.2M5.60005 4.23999V2.31999C5.60005 1.7898 6.02984 1.35999 6.56005 1.35999H9.44005C9.97026 1.35999 10.4 1.7898 10.4 2.31999V4.23999M8.00005 6.63999V14.32M10.88 6.63999L10.4 14.32M5.12005 6.63999L5.60005 14.32M13.76 4.23999L12.8682 15.8336C12.8297 16.3338 12.4127 16.72 11.9111 16.72H4.08904C3.5874 16.72 3.17034 16.3338 3.13187 15.8336L2.24005 4.23999H13.76Z" stroke="#000000" stroke-width="1.5"/>
          </svg>
        </div>
        <div>
          <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="iconify iconify--twemoji" fill="#fff" stroke="#fff">
            <path d="M34.5 1.4a3 3 0 0 0-4.2.9L13.5 28.2l-8.2-7.6a3 3 0 1 0-4 4.4L12 35l.4.3a3 3 0 0 0 4.2-.9L35.3 5.5a3 3 0 0 0-.8-4.1z"/>
          </svg>
        </div>
      </div>
    `;

    upsellPopup.insertAdjacentHTML('beforeend', upsellHTML);

    const btn = upsellPopup.querySelector('div:last-child > div.ve-0014-upsell-delete');
    btn.addEventListener('click', () => {
      const elemInCart = document.querySelector(`.line-item[data-vid="${u.id}"]:not(:has(.product-item-meta__property))`);

      if (elemInCart !== null) {
        const cartRemove = elemInCart.querySelector('.line-item__remove-button');
        cartRemove.click();
      }

      setTimeout(loadUpsell, 2000);

      addedUpsell.splice(addedUpsell.indexOf(u), 1);
    });
  });

  // Get product ID for recommendations API
  try {
    // Try to get product ID from data-productid attribute on product form
    const productForm = document.querySelector('.product-form[data-productid]');
    let productId = null;
    
    if (productForm) {
      productId = productForm.getAttribute('data-productid');
    } else {
      // Fallback: get product ID from variant
      const variantIdInput = document.querySelector('.product-form__buy-buttons form input[name="id"]');
      if (!variantIdInput) {
        console.warn('Could not find product ID or variant ID input');
        return;
      }

      const variantId = variantIdInput.value;
      
      // Fetch variant to get product_id
      const variantResponse = await fetch(`/variants/${variantId}.js`);
      if (!variantResponse.ok) {
        console.warn('Could not fetch variant data');
        return;
      }
      
      const variant = await variantResponse.json();
      productId = variant.product_id;
    }
    
    if (!productId) {
      console.warn('Could not determine product ID');
      return;
    }

    // Fetch recommendations from API
    // Use locale-aware URL if available, otherwise use root
    const rootPath = window.Shopify?.routes?.root || '/';
    const recommendationsUrl = `${rootPath}recommendations/products.json?product_id=${productId}&intent=related&limit=10`;
    console.log(recommendationsUrl);
    const recommendationsResponse = await fetch(recommendationsUrl);
    
    if (!recommendationsResponse.ok) {
      console.warn('Could not fetch product recommendations');
      return;
    }

    const recommendationsData = await recommendationsResponse.json();
    const recommendedProducts = recommendationsData.products || [];

    // Filter out products that are already in addedUpsell and products with "Gratis" in title
    const availableProducts = recommendedProducts.filter(product => {
      const firstVariantId = product.variants?.[0]?.id?.toString();
      const isAlreadyAdded = addedUpsell.find(u => u.id === firstVariantId);
      const hasGratisInTitle = product.title && product.title.toLowerCase().includes('gratis');
      return !isAlreadyAdded && !hasGratisInTitle;
    });

    // Render recommended products
    availableProducts.forEach((product) => {
      const firstVariant = product.variants?.[0];
      if (!firstVariant || !firstVariant.available) {
        return;
      }

      const variantId = firstVariant.id.toString();
      const productImage = product.featured_image || (firstVariant.featured_image || '');
      const productTitle = product.title;
      
      // Format price using formatMoney if available, otherwise use simple formatting
      let formattedPrice = '';
      if (typeof formatMoney === 'function') {
        formattedPrice = formatMoney(firstVariant.price);
      } else {
        // Fallback price formatting
        const priceInEuros = (firstVariant.price / 100).toFixed(2);
        formattedPrice = `${priceInEuros.replace('.', ',')} €`;
      }

      const upsellHTML = `
        <div>
          <img src="${productImage}">
          <h3>${productTitle}</h3>
          <p>${formattedPrice}</p>
          <div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.99999 0.800049V15.2M0.799988 8.00005H15.2" stroke="white" stroke-width="2"/>
            </svg>
          </div>
        </div>
      `;

      upsellPopup.insertAdjacentHTML('beforeend', upsellHTML);

      const btn = upsellPopup.querySelector('div:last-child > div:has(> svg)');
      btn.addEventListener('click', async () => {
        // Add product to cart
        try {
          const formData = {
            items: [{
              id: variantId,
              quantity: 1
            }]
          };

          const addToCartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });

          if (!addToCartResponse.ok) {
            const errorData = await addToCartResponse.json();
            throw new Error(errorData.description || 'Failed to add product to cart');
          }

          // Dispatch cart:updated event (but don't open cart)
          const cartResponse = await fetch('/cart.js');
          const cartContent = await cartResponse.json();
          
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cartContent }
            })
          );

          // Dispatch cart:refresh but explicitly prevent cart from opening
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: false
              }
            })
          );

          // Add to addedUpsell array
          addedUpsell.push({ 
            img: productImage, 
            title: productTitle, 
            price: formattedPrice, 
            id: variantId 
          });

          // Reload upsell list
          setTimeout(loadUpsell, 500);
        } catch (error) {
          console.error('Error adding product to cart:', error);
          alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
        }
      });
    });
  } catch (error) {
    console.error('Error loading upsell recommendations:', error);
  }
}

function openPopup() {
  const popup = document.querySelector('.ve-0014');
  const productPrice = popup.querySelector('.ve-0014-product-price');
  const productQt = popup.querySelector('.ve-0014-product-qt span');

  addedUpsell = [];

  const isAbo = document.querySelector('.subscription-radio.rc-radio--active') !== null;
  let pdpPrice = undefined;
  if (isAbo) {
    pdpPrice = document.querySelector('.price-wrap-outer .custom-price-2-wrap .price.price--large');
  } else {
    pdpPrice = document.querySelector('.price-wrap-outer .product-meta__price-list-container .price.price--large');
  }

  productPrice.innerHTML = pdpPrice.innerHTML.replace(/<span.*<\/span>/, '');

  const cartProduct = getProductInCart();
  let cartQt = { value: '0' };
  if (cartProduct !== null && cartProduct !== undefined) {
    cartQt = cartProduct.querySelector('.quantity-selector__input');
  }

  const pdpQt = document.querySelector('.product-form__quantity .quantity-selector__input');
  productQt.innerHTML = parseInt(cartQt.value) + parseInt(pdpQt.value);

  const upsellPopup = document.querySelector('.ve-0014-upsell-list');
  upsellPopup.innerHTML = '';

  setTimeout(() => {
    loadUpsell();
  }, 1000);

  popup.classList.add('ve-0014-open');
}

function closePopup() {
  const popup = document.querySelector('.ve-0014');
  popup.classList.remove('ve-0014-open');
}

document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add('as-ve-0014');

  const pos = window.scrollY;
  window.scrollTo(0, 0);
  setTimeout(() => {
    window.scrollTo(0, pos);
  }, 50);
});


domReady(() => {
  document.body.classList.add('as-ve-0014');

  const pos = window.scrollY;
  window.scrollTo(0, 0);
  setTimeout(() => {
    window.scrollTo(0, pos);
  }, 50);
});

// Replace ablyftTools.waitForElement for product image
waitForElement('.flickity-slider .product__media-item:first-child .product__media-image-wrapper > img', () => {
  addPopup();
  setupPopup();
});

// Replace ablyftTools.waitForElement for ATC buttons
waitForElement('#AddToCart', (atc) => {
  console.log("FOUND ATC", atc)
  atc.addEventListener('click', () => {
    console.log("CLICKED")
    preventCartOpening();
    openPopup();
  });
});





const dataMap = {
  '/products/vegan-protein-vanille': {
    '3er': {
      title: '3x Vanille - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-bourbon-vanille-min_1000x.jpg?v=1759386824',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830643671417',
    },
    '5er': {
      title: '5x Vanille - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-bourbon-vanille-min_1000x.jpg?v=1759387172',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25.49 /Stück',
      badge: '-15%',
      id: '55830667067769',
    },
  },
  '/products/vegan-protein-zimt': {
    '3er': {
      title: '3x Zimt - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-zimt-min_1000x.jpg?v=1759387053',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830728933753',
    },
    '5er': {
      title: '5x Zimt - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-zimt-min_1000x.jpg?v=1759387377',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830733586809',
    },
  },
  '/products/vegan-protein-kakao': {
    '3er': {
      title: '3x Kakao - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-kakao-min_1000x.jpg?v=1759386853',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830668542329',
    },
    '5er': {
      title: '5x Kakao - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-kakao-min_1000x.jpg?v=1759387203',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830670115193',
    },
  },
  '/products/vegan-protein-waldbeere': {
    '3er': {
      title: '3x Beere - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-waldbeere-min_1000x.jpg?v=1759386879',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830673523065',
    },
    '5er': {
      title: '5x Beere - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-waldbeere-min_1000x.jpg?v=1759387228',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830676341113',
    },
  },
  '/products/vegan-protein-banane': {
    '3er': {
      title: '3x Banane - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-banane-min_1000x.jpg?v=1759386995',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830715203961',
    },
    '5er': {
      title: '5x Banane - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-banane-min_1000x.jpg?v=1759387326',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830717301113',
    },
  },
  '/products/vegan-protein-neutral': {
    '3er': {
      title: '3x Neutral - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-neutral-min_1000x.jpg?v=1759386910',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830678569337',
    },
    '5er': {
      title: '5x Neutral - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-neutral-min_1000x.jpg?v=1759387255',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830679945593',
    },
  },
  '/products/vegan-protein-haselnuss-600g-bio': {
    '3er': {
      title: '3x Haselnuss - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-haselnuss-min9_1000x.jpg?v=1759387564',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830699213177',
    },
    '5er': {
      title: '5x Haselnuss - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-haselnuss-min_1000x.jpg?v=1759387304',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830708519289',
    },
  },
  '/products/vegan-protein-matcha-latte-600g-bio': {
    '3er': {
      title: '3x Matcha-Latte - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-matcha-latte-classic-min_1000x.jpg?v=1759386934',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830681682297',
    },
    '5er': {
      title: '5x Matcha-Latte - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-matcha-latte-classic-min_1000x.jpg?v=1759387280',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830688235897',
    },
  },
  '/products/vegan-protein-iced-coffee-600g-bio': {
    '3er': {
      title: '3x Iced-Coffee - Spare 10%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-iced-coffee-classic-min_1000x.jpg?v=1759387027',
      price: '€80,97',
      comparePrice: '€89,97',
      unitPrice: '€26,99 /Stück',
      badge: '-10%',
      id: '55830718873977',
    },
    '5er': {
      title: '5x Iced-Coffee - Spare 15%',
      img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-iced-coffee-classic-min_1000x.jpg?v=1759387353',
      price: '€127,46',
      comparePrice: '€149,95',
      unitPrice: '€25,49 /Stück',
      badge: '-15%',
      id: '55830724804985',
    },
  },
};

document.body.classList.add('as-ve-0031');

waitForElement('.ve-0014-upsell-list', (upsells) => {
  const path = window.location.pathname.replace(/\/collections\/[^\/]*/, '');
  const data = dataMap[path];

  if (data === undefined) {
    return;
  }

  const title = upsells.parentElement.querySelector('h2');
  title.innerHTML = 'Mehr kaufen, weniger zahlen:';

  const newUpsellsHTML = `
    <div class="ve-0031-upsell-list">
      <div class="ve-0031-item" data-id="${data['3er'].id}">
        <p class="ve-0031-item-badge">${data['3er'].badge}</p>
        <img src="${data['3er'].img}">
        <h3>${data['3er'].title}</h3>
        <p class="ve-0031-item-price">${data['3er'].price}<span>${data['3er'].comparePrice}</span></p>
        <p class="ve-0031-item-unit">${data['3er'].unitPrice}</p>
        <div>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99999 0.800049V15.2M0.799988 8.00005H15.2" stroke="white" stroke-width="2"></path>
          </svg>
        </div>
      </div>
      <div class="ve-0031-item" data-id="${data['5er'].id}">
        <p class="ve-0031-item-badge">${data['5er'].badge}</p>
        <img src="${data['5er'].img}">
        <h3>${data['5er'].title}</h3>
        <p class="ve-0031-item-price">${data['5er'].price}<span>${data['5er'].comparePrice}</span></p>
        <p class="ve-0031-item-unit">${data['5er'].unitPrice}</p>
        <div>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99999 0.800049V15.2M0.799988 8.00005H15.2" stroke="white" stroke-width="2"></path>
          </svg>
        </div>
      </div>
    </div>
  `;

  upsells.insertAdjacentHTML('beforebegin', newUpsellsHTML);

  const items = document.querySelectorAll('.ve-0031-item');
  items.forEach((item) => {
    const id = item.dataset.id;
    const btn = item.querySelector('div:has(> svg)');

    btn.addEventListener('click', () => {
      const originalProductIDElem = document.querySelector('.product-form__buy-buttons input[name="id"]');
      const originalProductID = parseInt(originalProductIDElem.getAttribute('value'));

      const originalQuantityElem = document.querySelector('.quantity-selector__input');
      const originalQuantity = originalQuantityElem.value;

      fetch('/cart.js', {
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          let toRemoveQt = originalQuantity;

          const products = data.items.filter((elem) => {
            return elem.id === originalProductID && elem.selling_plan_allocation === undefined;
          });

          const set = data.items.find((elem) => {
            return elem.id === parseInt(id);
          });

          const updates = {};

          products.forEach((product) => {
            if (toRemoveQt <= 0) {
              return;
            }

            let newQt = 0;
            if (toRemoveQt < product.quantity) {
              newQt = product.quantity - toRemoveQt;
            }

            toRemoveQt -= product.quantity;

            updates[product.key] = newQt;
          });

          if (set !== undefined) {
            updates[id] = set.quantity + 1;
          } else {
            updates[id] = 1;
          }

          const closeBtn = document.querySelector('.ve-0014-footer-cart');

          setTimeout(() => {
            closeBtn.classList.add('ve-0031-ignore');
            closeBtn.click();
            closeBtn.classList.remove('ve-0031-ignore');
          }, 1000);

          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          }).then((response) => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
              })
            );
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });
});

waitForElement('#AddToCart', (atc) => {
  atc.addEventListener('click', () => {
    const atcText = document.querySelector('#AddToCart .loader-button__text');
    if (atcText.innerHTML === 'In den Warenkorb') {
      window['ablyft'].push({
        eventType: 'custom',
        eventName: 've-0031-click-atc-einmalig',
        eventValue: 0, //optional
      });
    } else {
      window['ablyft'].push({
        eventType: 'custom',
        eventName: 've-0031-click-atc-abo',
        eventValue: 0, //optional
      });
    }
  });
});

waitForElement('#StickyAddToCart', (atc) => {
  atc.addEventListener('click', () => {
    const atcText = document.querySelector('#AddToCart .loader-button__text');
    if (atcText.innerHTML === 'In den Warenkorb') {
      window['ablyft'].push({
        eventType: 'custom',
        eventName: 've-0031-click-sticky-atc-einmalig',
        eventValue: 0, //optional
      });
    } else {
      window['ablyft'].push({
        eventType: 'custom',
        eventName: 've-0031-click-sticky-atc-abo',
        eventValue: 0, //optional
      });
    }
  });
});







// Subscription Variante vorauwählen

waitForElement('recharge-subscription-widget', (widget) => {
  const shadowStart = Date.now();
  const checkShadow = setInterval(() => {
    if (!widget.shadowRoot) {
      if (Date.now() - shadowStart > 10000) clearInterval(checkShadow);
      return;
    }
    clearInterval(checkShadow);
    waitForElement('.rc-purchase-option input[type="radio"]', () => {
      // Select subscription (anything that is NOT "onetime")
      const subscriptionRadio = Array.from(
        widget.shadowRoot.querySelectorAll('.rc-purchase-option input[type="radio"]')
      ).find(input => input.value !== 'onetime');

      if (subscriptionRadio) {
        subscriptionRadio.checked = true;
        subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 100, 10000, widget.shadowRoot);
  }, 100);
});